import React from "react";
// import classes from "../AboutUs/AboutUs.module.css";
// import aeroplane from "../AboutUs/AboutUs-images/aeroplane.jpeg";

const AboutUs = () => {
  return <div>
    {/* <div className={classes.white}>
      <div className={classes.heading}>
        <h1> About Us</h1>
        <p>Learn More about AtEase</p>
      </div>
      <div className={classes.plane}>
      <img src={aeroplane} alt="plane in flight" />
      </div>

      <section className={classes.description}>
        <div>
          <h2> WHO WE ARE: </h2>
          <p> ATEASE INSURANCE is a consortium of young,dynamic and result-driven experts with the intent of providing insurance policies for Start-ups and Freelancers in Nigeria.</p>
        </div>
        <div>
          <h2> OUR VISION: </h2>
          <p>To be Africa's foremost digital insurance firm providing policy for Start-ups and Freelancers in the Tech sphere. </p>
        </div>
        <div>
          <h2> OUR MISSION: </h2>
          <p>To provide affordable insurance cover to Start-ups and Freelancers with AtEase insurance you can be truly at ease.</p>
        </div>
      </section>
    </div> */} 
  </div>;
};

export default AboutUs;
